// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Criteria = t.struct({
    currentMachineHours: t.maybe(t.Number),
    partNumber: t.String,
    pin: t.String
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        currentMachineHours: null,
        partNumber: '',
        pin: ''
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/state/criteria.js